// E:\projetos\nlb-erp-crm\apps\web\src\services\AuthService.js

import api from 'services/api';
import { AUTH_TOKEN } from 'constants/AuthConstant';

// ✅ mesma chave usada no authSlice + interceptor
export const ACTIVE_COMPANY_ID = 'activeCompanyId';
export const AUTH_USER = 'AUTH_USER';

class AuthService {
  /**
   * ✅ Login (backend retorna: { access_token, user })
   * - salva token
   * - salva user
   * - salva activeCompanyId (para o interceptor enviar x-company-id)
   * Retorna exatamente o payload do backend
   */
  async login(email, password) {
    const res = await api.post('/auth/login', {
      email,
      password,
    });

    const data = res.data || {};
    const token = data.access_token;
    const user = data.user;

    if (token) {
      localStorage.setItem(AUTH_TOKEN, token);

      // compat: alguns pontos do template usam "token"
      localStorage.setItem('token', token);
    }

    if (user) {
      localStorage.setItem(
        AUTH_USER,
        JSON.stringify(user)
      );

      if (user.activeCompanyId) {
        localStorage.setItem(
          ACTIVE_COMPANY_ID,
          String(user.activeCompanyId)
        );

        // compat: seu interceptor antigo procurava "companyId"
        localStorage.setItem(
          'companyId',
          String(user.activeCompanyId)
        );
      } else {
        localStorage.removeItem(ACTIVE_COMPANY_ID);
        localStorage.removeItem('companyId');
      }
    } else {
      localStorage.removeItem(AUTH_USER);
      localStorage.removeItem(ACTIVE_COMPANY_ID);
      localStorage.removeItem('companyId');
    }

    return data;
  }

  /**
   * ✅ Me (usa a instância api, que já injeta Authorization)
   */
  async me() {
    const token =
      localStorage.getItem(AUTH_TOKEN) ||
      localStorage.getItem('token');

    if (!token) {
      throw new Error('Sem token');
    }

    const res = await api.get('/auth/me', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const me = res.data;

    // se o backend devolver activeCompanyId, sincroniza
    if (me?.activeCompanyId) {
      localStorage.setItem(
        ACTIVE_COMPANY_ID,
        String(me.activeCompanyId)
      );

      localStorage.setItem(
        'companyId',
        String(me.activeCompanyId)
      ); // compat
    }

    return me;
  }

  /**
   * ✅ Troca empresa ativa no front (somente muda contexto local)
   * - usado pelo seletor de empresa
   * - depois disso, qualquer request já vai com x-company-id
   */
  setActiveCompany(companyId) {
    if (!companyId) {
      localStorage.removeItem(ACTIVE_COMPANY_ID);
      localStorage.removeItem('companyId');
      return;
    }

    localStorage.setItem(
      ACTIVE_COMPANY_ID,
      String(companyId)
    );

    localStorage.setItem(
      'companyId',
      String(companyId)
    ); // compat
  }

  /**
   * ✅ Logout
   */
  logout() {
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem('token');
    localStorage.removeItem(AUTH_USER);
    localStorage.removeItem(ACTIVE_COMPANY_ID);
    localStorage.removeItem('companyId');
  }
}

export default new AuthService();